import styled from 'styled-components/macro';
import { Container, Col } from '@yme/atoms/grid';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
export const SeparatorWrapper = styled.div `
  box-sizing: border-box;
  position: relative;

  padding-top: 56px;

  ${ADAPTIVE.minWidth.tablet} {
    padding-top: 64px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    padding-top: 96px;
  }
`;
export const SectionWrapperStyled = styled.section `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const ContainerStyled = styled(Container) `
  position: absolute;
  top: 0;
  left: 0;
`;
export const ColStyled = styled(Col) `
  position: relative;

  &:empty {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: ${colorCoreGray500};
    }
  }
`;
